import React, { FC } from 'react';

import { Badge, Drawer, Group, Text } from '@mantine/core';

import { useInbox } from 'hooks/use-inbox';
import { useIsMobile } from 'hooks/use-is-mobile';
import { NotificationService } from 'services/NotificationService';

import { Inbox } from './Inbox';
import { InboxActions } from './InboxActions';

import cx from './Inbox.module.scss';

const InboxDrawer: FC = () => {
    const isMobile = useIsMobile('md');

    const { opened } = useInbox();

    return (
        <Drawer
            className={cx.notificationDrawer}
            opened={opened}
            onClose={NotificationService.closeInbox}
            position="right"
            size={isMobile ? 'xl' : 'lg'}
            title={
                <Group justify="space-between" gap="xs">
                    <InboxTitle />
                    <InboxActions />
                </Group>
            }
            styles={{ title: { flex: 1, marginRight: 'var(--mantine-spacing-md)' } }}
            overlayProps={{
                opacity: 0.5,
            }}
        >
            <Inbox fillHeight />
        </Drawer>
    );
};

const InboxTitle = () => {
    const { unreadCount } = useInbox();

    return (
        <Group gap={6} wrap="nowrap">
            <Text fw={700} fz="lg">
                Inbox
            </Text>
            {unreadCount > 0 && (
                <Badge size="sm" variant="filled" color="red" style={{ overflow: 'visible', flexShrink: 0 }}>
                    {unreadCount}
                </Badge>
            )}
        </Group>
    );
};

export { InboxDrawer };
